import styled from 'styled-components';
import grey from 'sushiweb/tokens/color/grey';
import white from 'sushiweb/tokens/color/white';
import red from 'sushiweb/tokens/color/red';
import black from 'sushiweb/tokens/color/black';
import blue from 'sushiweb/tokens/color/blue';
import { yellow } from 'sushiweb/tokens/color';
import Layout from 'sushiweb/Layout';
import Dropdown from 'sushiweb/Dropdown';
import Input from 'sushiweb/InputTypes/Input';
import ChevronDown from 'sushiweb/Icons/all/ChevronDown';
import ChevronUp from 'sushiweb/Icons/all/ChevronUp';
import OnClickOutside from 'sushiweb/HOC/OnClickOutside';
import { P } from 'sushiweb/Typography/Text';
import { selectFrequency } from '../constants';

export const CreateProgramContainer = styled.div`
  max-height: ${props =>
    selectFrequency.includes(props.frequency) ? '76vh' : '73.2vh'};
  overflow-y: scroll;
  overflow-x: hidden;
  ::-webkit-scrollbar {
    display: none;
  }
  width: 70rem;
  padding: 1.8rem 2.4rem 7.2rem;

  @media (max-width: 480px) {
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;

export const DropdownContainer = styled(OnClickOutside)`
  position: relative;
  width: 100%;
  height: 5.5rem;
  margin-top: 0.8rem;
`;

export const DaysDropdown = styled(OnClickOutside)`
  position: relative;
  width: 100%;
  height: 5.5rem;
  margin-top: 0.8rem;
`;

export const CustomDropdown = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  background: ${white};
  width: 100%;
  height: 100%;
  border: ${({ open, custom }) =>
    open || custom ? `0.1rem solid ${red.z500}` : `0.1rem solid ${grey.z300}`};
  border-radius: 0.6rem;
  cursor: pointer;
  padding: 0 1.2rem;
  p {
    width: calc(100% - 3rem);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    font-size: 1.8rem !important;
    color: ${({ dark }) => (!dark ? grey.z400 : grey.z800)} !important;
    margin-bottom: 0 !important; // for removing default 1.5rem sushi Paragraph margin
    font-weight: 300;
  }
`;

export const DateContainer = styled.div`
  width: 4rem;
  height: 4rem;
  cursor: pointer;
  font-size: 1.26rem;
`;

DateContainer.Background = styled.div`
  width: 2.8rem;
  height: 2.8rem;
  border-radius: 50%;
  background: ${({ selected }) => (selected ? red.z500 : white)};
  color: ${({ selected }) => (selected ? white : black)};
  &:hover {
    background: ${({ selected }) => (selected ? red.z500 : grey.z200)};
  }
`;

export const DropdownOptions = styled.div`
  position: absolute;
  top: 5.3rem;
  width: 100%;
  height: max-content;
  padding: 0.4rem 0;
  border-radius: 0.6rem;
  background: ${white};
  box-shadow: 0px 1px 8px rgb(28 28 28 / 15%);
  z-index: 10;
  overflow: hidden;
  p {
    margin-bottom: 0 !important; // required to center the content
  }
`;

DropdownOptions.Groups = styled.div`
  width: 100%;
  height: max-content;
  max-height: 19rem;
  padding-bottom: 5rem;
  overflow-y: scroll;
`;

DropdownOptions.Month = styled.div`
  width: 100%;
  height: 26.6rem;
  display: grid;
  padding: 0.8rem 0.3rem;
  grid-template-columns: 4rem 4rem 4rem 4rem 4rem 4rem 4rem;
  grid-template-rows: 4rem 4rem 4rem 4rem;
`;

DropdownOptions.ApplyFilter = styled.div`
  position: absolute;
  width: 100%;
  height: 5rem;
  padding: 0 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: ${white};
  bottom: 0;
  box-shadow: 0px -1px 20px rgba(0, 0, 0, 0.1);
  button {
    margin-left: auto;
  }
`;

export const CheckedBox = styled.div`
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.4rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${red.z500};
`;

export const UncheckedBox = styled.div`
  min-width: 1.5rem;
  height: 1.5rem;
  border-radius: 0.4rem;
  background: ${white};
  border: 0.1rem solid ${props => (!props.disabled ? grey.z600 : grey.z400)};
`;

export const StyledChevronDown = styled(ChevronDown)`
  position: absolute;
  right: 1.2rem;
`;

export const StyledChevronUp = styled(ChevronUp)`
  position: absolute;
  right: 1.2rem;
`;

export const NeverEnd = styled.div`
  margin-top: -20px;
  width: 100%;
  margin-bottom: 5px;
`;

NeverEnd.Container = styled.div`
  display: flex;
  align-items: flex-start;
  input {
    margin: 0.2rem 1rem 0 0;
    cursor: pointer;
    width: 1.8rem;
    height: 1.8rem;
  }
  font-size: 1.6rem;
  color: ${grey.z900};
`;

NeverEnd.HelperText = styled.div`
  margin-top: 5px;
  margin-left: 27px;
  display: flex;
  justifycontent: left;
  color: ${grey.z500};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 14px; /* 116.667% */
`;

export const ApplyLimitsWrapper = styled.div`
  width: 100%;
  margin-bottom: ${props => (!props.isLimitsApplied ? '5rem' : '1rem')};
`;

ApplyLimitsWrapper.Container = styled.div`
  display: flex;
  align-items: flex-start;
  input {
    margin: 0.2rem 1rem 0 0;
    cursor: pointer;
    width: 1.8rem;
    height: 1.8rem;
  }
  font-size: 1.6rem;
  color: ${grey.z900};
`;

ApplyLimitsWrapper.HelperText = styled.div`
  margin-top: 5px;
  margin-left: 28px;
  display: flex;
  justifycontent: left;
  color: ${grey.z500};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 14px; /* 116.667% */
`;
export const styledInputBox = styled.input`
  margin: 0.2rem 1rem 0 0;
  cursor: pointer;
  width: 1.8rem;
  height: 1.8rem;
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
  p {
    font-size: 1.6rem;
    color: ${grey.z900};
  }
`;

InputWrapper.HelperText = styled.div`
  font-size: 1.3rem;
  color: ${grey.z500};
`;
export const HelperTextWrapper = styled.div`
  margin-top: -20px;
  display: flex;
  justify-content: left;
  color: ${grey.z500};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 14px; /* 116.667% */
`;

export const QuestionsHelperTextWrapper = styled.div`
  padding-bottom: 35px;
  display: flex;
  justifycontent: left;
  color: ${grey.z500};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 14px; /* 116.667% */
`;

export const StyledDropdown = styled(Dropdown)`
  margin-top: 1.2rem;
`;

export const StyledAddSlotsDropdown = styled(Dropdown)`
  margin-top: 1.2rem;
  width: 100%;
  border-radius: 12px;
  border: 1px dashed var(--coolgreycoolgrey-300, #d0d4dc);
`;

export const StyledLayout = styled(Layout)`
  margin-bottom: 1.3rem;
  margin-top: 1.3rem;
`;

export const StyledInput = styled(Input)`
  margin-top: 1.2rem;
  width: 100%;
`;
export const StyledInputV2 = styled(Input)`
  width: 100%;
`;
export const RadioOptions = styled.div`
  width: 100%;
  display: flex;
  margin-top: 1.2rem;
`;

export const RadioWrapper = styled.div`
  display: flex;
  align-items: center;
  p {
    font-size: 1.6rem;
    margin-left: 0.8rem;
  }
  input {
    margin: 0;
  }
  :nth-child(2) {
    margin-left: 3rem;
  }
`;

export const ExpiryWrapper = styled.div`
  display: flex;
  flex-direction: row;
  div {
    margin-left: 0.2rem;
  }
`;

export const ErrorContainer = styled.div`
  text-align: left;
  padding: 0.2rem 1rem;
  background: ${red.z100};
  p {
    color: ${red.z500};
    font-size: 1.3rem;
    font-weight: 500;
  }
  border: 1px solid ${red.z200};
  border-radius: 0.4rem;
`;

export const StyledP = styled(P)`
  display: inline;
`;

export const CreateProgramButtonDiv = styled.div`
  height: '6.5rem';
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: space-between;
  flex-direction: row-reverse;
  position: fixed;
  bottom: 0;
  width: 100%;
  background: ${white};
  left: 0;
  padding: 1.2rem 2.4rem;
  box-shadow: 0px -1px 20px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  border-radius: 0 0 0.6rem 0.6rem;
`;

export const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 0.9rem 1.4rem;
  cursor: pointer;
  p {
    font-size: 1.6rem;
    color: ${grey.z800};
    margin-left: 0.8rem;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
  &:hover {
    background: ${grey.z100};
  }
`;

export const WarningContainer = styled.div`
  text-align: center;
  margin-top: 1rem;
  padding: 0.5rem 1rem;
  background: ${yellow.z100};
  color: ${yellow.z800};
  border: 1px solid ${yellow.z300};
  border-radius: 0.4rem;
  font-size: 1.3rem;
  font-weight: 500;
`;

export const HeadTitleContainer = styled.h4`
  display: inline;
  padding: 0rem 1rem;
  margin: 0rem;
`;

export const CrossDiv = styled.div`
  cursor: pointer;
  margin: 2.5rem 0;
`;

export const TableClickButton = styled.div`
  font-weight: 500;
  color: ${blue.z500};
  text-decoration: none;
  &:hover {
    opacity: 0.8;
  }
  margin: 0;
  padding: 0;
`;

export const TableClickButtonOverflow = styled.div`
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropDownHeaderTextWrapper = styled.div`
  color: ${grey.z400};
`;

export const DropDownTextWrapper = styled.div`
  color: ${grey.z800};
`;

export const TopupType = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 2rem;
`;

TopupType.Text = styled.div`
  color: ${grey.z600};
  font-size: 17px;
  font-style: normal;
  font-weight: 400;
  line-height: 22px; /* 137.5% */
`;

TopupType.YesText = styled.div`
  padding-top: 2px;
  padding-right: 10px;
  color: ${grey.z600};
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 137.5% */
`;

TopupType.HelperText = styled.div`
  margin-top: 5px;
  display: flex;
  justifycontent: left;
  color: ${grey.z500};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 14px; /* 116.667% */
`;

export const DailyRestrictions = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 1rem;
`;

DailyRestrictions.Text = styled.div`
  color: ${grey.z600};
  font-size: 17.5px;
  font-style: normal;
  font-weight: 400;
`;

DailyRestrictions.YesText = styled.div`
  padding-top: 2px;
  padding-right: 10px;
  color: var(--coolgreycoolgrey-800, #414a5d);
  font-size: 16px;
  font-style: normal;
  font-weight: 500;
  line-height: 22px; /* 137.5% */
`;

DailyRestrictions.HelperText = styled.div`
  margin-top: 5px;
  display: flex;
  justifycontent: left;
  color: ${grey.z500};
  font-size: 12px;
  font-style: normal;
  font-weight: 300;
  line-height: 14px; /* 116.667% */
`;

export const SwitchWrapper = styled.div`
  display: flex;
`;

export const DottedLine = styled.div`
  border-bottom: 1px dotted #e6e9ef;
  width: 100%;
`;

export const FundsSummaryWrapper = styled.div`
  display: flex;
  margin-top: 50px;
`;

export const FundsSummaryText = styled.div`
  margin-left: 15px;
  flex-direction: column;

  hr {
    border-top: 1px dotted #f00;
    color: #fff;
    background-color: #e6e9ef;
    height: 1px;
    width: 80%;
  }

  h5 {
    color: var(--coolgreycoolgrey-800, #414a5d);
    font-size: 18px;
    font-style: normal;
    font-weight: 600;
  }
  h6 {
    color: var(--coolgreycoolgrey-800, #414a5d);
    font-size: 16px;
    font-style: normal;
    font-weight: 500;
  }

  p {
    color: var(--coolgreycoolgrey-600, #767c8f);
    font-size: 15px;
    font-style: normal;
    font-weight: 400;
    margin-top: 8px;
    line-height: 22px; /* 137.5% */
  }
`;

export const CreateProgramBtnWrapper = styled.div`
  border-top: 1px solid ${grey.z200};
  display: flex;
  justify-content: end;
  padding: 20px;
`;
